module.exports = __webpack_public_path__ + "static/media/Architecture_16.faa6ae51.jpg";